var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmailTempIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7046_146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8984 48.8984C17.8984 29.5685 33.5685 13.8984 52.8984 13.8984C72.2284 13.8984 87.8984 29.5685 87.8984 48.8984C87.8984 68.2284 72.2284 83.8984 52.8984 83.8984C33.5685 83.8984 17.8984 68.2284 17.8984 48.8984Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5144 36.0336L66.8064 43.4574C67.2054 43.7197 67.4049 43.8509 67.5495 44.0258C67.6774 44.1807 67.7735 44.3598 67.8322 44.5527C67.8984 44.7707 67.8984 45.0113 67.8984 45.4927V56.6161C67.8984 59.1651 67.8984 60.4397 67.408 61.4133C66.9765 62.2697 66.2881 62.966 65.4414 63.4024C64.4788 63.8984 63.2187 63.8984 60.6984 63.8984H45.0984C42.5782 63.8984 41.3181 63.8984 40.3555 63.4024C39.5088 62.966 38.8203 62.2697 38.3889 61.4133C37.8984 60.4397 37.8984 59.1651 37.8984 56.6161V45.4927C37.8984 45.0113 37.8984 44.7707 37.9647 44.5527C38.0233 44.3598 38.1195 44.1807 38.2474 44.0258C38.392 43.8509 38.5915 43.7197 38.9905 43.4574L50.2825 36.0336M55.5144 36.0336C54.5675 35.4111 54.0941 35.0998 53.584 34.9787C53.1331 34.8717 52.6638 34.8717 52.2129 34.9787C51.7028 35.0998 51.2294 35.4111 50.2825 36.0336M55.5144 36.0336L66.3505 43.1577C66.8664 43.4968 67.1244 43.6664 67.2137 43.8815C67.2918 44.0694 67.2918 44.2812 67.2137 44.4692C67.1244 44.6842 66.8664 44.8538 66.3505 45.193L55.5144 52.3171C54.5675 52.9396 54.0941 53.2508 53.584 53.3719C53.1331 53.479 52.6638 53.479 52.2129 53.3719C51.7028 53.2508 51.2294 52.9396 50.2825 52.3171L39.4463 45.193C38.9304 44.8538 38.6725 44.6842 38.5832 44.4692C38.5051 44.2812 38.5051 44.0694 38.5832 43.8815C38.6725 43.6664 38.9304 43.4968 39.4463 43.1577L50.2825 36.0336M56.2318 52.2509L64.5651 63.0224M41.2318 63.0224L49.5651 52.2509",
    stroke: "#3953FB",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7046_146",
    x: -0.00156212,
    y: -0.00156212,
    width: 105.8,
    height: 105.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7046_146"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7046_146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7046_146",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmailTempIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/emailTempIcon.cc247b60.svg";
export { ForwardRef as ReactComponent };